import React, { useState } from "react";
import { Phone, X } from "lucide-react";

const FloatingCallButton = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="fixed bottom-5 left-5 z-[9998]">
      {/* Expanded popup */}
      {isOpen && (
        <div className="absolute bottom-16 left-0 bg-white rounded-xl shadow-2xl border border-gray-200 p-4 w-56 animate-fade-in">
          <p className="font-poppins font-semibold text-[#1a1a1a] text-sm mb-3">
            Call Us
          </p>
          <a
            href="tel:+919751203819"
            className="flex items-center gap-3 px-3 py-2.5 rounded-lg hover:bg-[#F0FAFA] transition-colors mb-2"
          >
            <div className="w-8 h-8 rounded-full bg-[#1CA0B9] flex items-center justify-center flex-shrink-0">
              <Phone className="w-4 h-4 text-white" />
            </div>
            <div>
              <p className="font-poppins text-[#1a1a1a] text-sm font-medium leading-tight">
                +91 97512 03819
              </p>
              <p className="font-poppins text-[#999] text-[10px]">Mobile</p>
            </div>
          </a>
          <a
            href="tel:04242240802"
            className="flex items-center gap-3 px-3 py-2.5 rounded-lg hover:bg-[#F0FAFA] transition-colors"
          >
            <div className="w-8 h-8 rounded-full bg-[#1CA0B9] flex items-center justify-center flex-shrink-0">
              <Phone className="w-4 h-4 text-white" />
            </div>
            <div>
              <p className="font-poppins text-[#1a1a1a] text-sm font-medium leading-tight">
                0424 224 0802
              </p>
              <p className="font-poppins text-[#999] text-[10px]">Landline</p>
            </div>
          </a>
        </div>
      )}

      {/* FAB Button */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className={`w-14 h-14 rounded-full shadow-lg flex items-center justify-center transition-all duration-300 ${
          isOpen
            ? "bg-[#333] hover:bg-[#555]"
            : "bg-[#1CA0B9] hover:bg-[#1890a5] animate-call-pulse"
        }`}
        aria-label="Call us"
      >
        {isOpen ? (
          <X className="w-6 h-6 text-white" />
        ) : (
          <Phone className="w-6 h-6 text-white" />
        )}
      </button>
    </div>
  );
};

export default FloatingCallButton;
